/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import { SolutionTemplate } from "@/components/landing/solution-template";
import { residentialConstructionConfig } from "./residential-construction-config";

export function ResidentialConstructionSolutionsPageClient() {
  return <SolutionTemplate config={residentialConstructionConfig} />;
}
